import { observable, action } from 'mobx';

class DrawerStore {

    @observable isDrawerOpen = false;
    @observable currentStep;
    @observable maxLengthStep = 7;
    @observable asyncComponenteLoading = true;
    
    @action
    setAsyncComponenteLoading(boolean) {
      this.asyncComponenteLoading = boolean
    }

    @action
    toggleDrawer(boolean) {
        this.isDrawerOpen = boolean
    }

    @action
    setCurrentStep(step) {
        this.currentStep = step
    }

    @action
    backOneStep() {
        this.currentStep -= 1
    }

    @action
    plusOneStep() {
        this.currentStep += 1
    }

    @action
    setLoading() {
        this.loading = true;
    }

    @action
    unsetLoading() {
        this.loading = false;
    }
}

export default new DrawerStore();




// WEBPACK FOOTER //
// ./src/stores/DrawerStore.js